import moment from 'moment';
import React from 'react';
// Agenda Page and Slot Allotment notification
const SixthStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    venue_name,
    address,
    map_link,
    zoom_link,
    registration_date_time,
    conference_location,
    hall_ticket_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Dear ${client_name},` : ` Dear [Client Name],`}</p>

      <p>
        Final agenda for{' '}
        {conference_short_name
          ? conference_short_name
          : `[Conference Short Name]`}
        . The detailed agenda is attached, outlining sessions, workshops, and
        networking events.
      </p>

      <p>
        Venue: {venue_name ? venue_name : `[Venue Name]`}
        <br />
        {address ? address : `[Adress]`}
        <br />
        {map_link ? <a href={map_link}>{map_link}</a> : `[Google Maps Link]`}
      </p>

      <p>
        Zoom Link for virtual participation:{' '}
        {zoom_link ? <a href={zoom_link}>{zoom_link}</a> : `[Access Zoom Link]`}
      </p>
      <p>
        On-site registration:{' '}
        {registration_date_time
          ? moment(registration_date_time).format('YYYY-MM-DD [and] HH:mm')
          : '[Date and Time]'}
        ,{conference_location ? conference_location : `[Location]`}
        <br />
        Bring: ID, registration confirmation, and presentation materials.
      </p>
      <p>
        Access your hall ticket/Zoom link here:{' '}
        {hall_ticket_link ? (
          <a href={hall_ticket_link}>{hall_ticket_link}</a>
        ) : (
          `[Access Link]`
        )}
        .
      </p>
      <p>We look forward to your participation and a successful event!</p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default SixthStepWhatsappTemplate;
